module.exports = __webpack_public_path__ + "img/20191025172145775.905a925a.jpg";